import Base from 'app/views/base';

import tmpl from 'templates/webhook_list';
import WebhookCreateModal from 'app/views/modals/webhook_create_modal';
import WebhookListItemView from 'app/views/webhook_list_item_view';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click .create_webhook': 'showCreateModal',
  },

  initialize(options) {
    this.apiMode = options.apiMode;
    this.listenTo(this.collection, 'sync', this.render);
    this.listenTo(this.collection, 'remove', this.render);
    this.createModal = new WebhookCreateModal({ collection: this.collection });
  },

  beforeRender() {
    this.removeSubviews();
    this.collection.each((model) => {
      this.addSubview(`webhook_${model.id}`, `#webhook_${model.id}`, new WebhookListItemView({
        model,
        collection: this.collection,
      }));
    });
  },

  context() {
    return {
      apiMode: this.apiMode.get('mode'),
      webhooks: this.collection.models,
    };
  },

  showCreateModal(event) {
    event.preventDefault();
    this.createModal.show();
  },
});



// WEBPACK FOOTER //
// ./app/views/webhook_list_view.js